import { Component, Input } from '@angular/core';

import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-radio',
  templateUrl: './element-radio.component.html',
  styleUrl: './element-radio.component.scss'
})
export class ElementRadioComponent extends ElementBase {
  @Input() showCompletionWarning: boolean = false;
}
